exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preg[data-v-6b9e133d]{padding:8px!important}.bg-primary[data-v-6b9e133d]{background-color:#1ab394;border-color:#1ab394;color:#fff}", ""]);

// exports
